<template>
  <div class="page">
    <div class="left">
      <van-swipe class="left-swipe" :autoplay="3000" :show-indicators="false">
        <van-swipe-item v-for="(item, index) in leftSwipeData" :key="index">
          <div class="img-box">
            <img :src="item.img" alt="" @click="toUrl(item.link)" />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="right">
      <div class="item" @click="toPage('productFilter')">
        <img
          src="https://static.xchengtech.cn/0416e5d318c14ccb871aa8180ac43c55.png"
          alt=""
        />
      </div>
      <div class="item" @click="toPage('productInformation')">
        <img
          src="https://static.xchengtech.cn/3091686b475a44528b0029ae35c0d590.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { getBanner } from "@/api/product";
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  mounted() {
    getBanner().then((res) => {
      res.sort((a, b) => {
        return a.sort - b.sort;
      });
      this.leftSwipeData = res;
    });
  },
  data() {
    return {
      // 左侧轮播图
      leftSwipeData: [],
      // 右侧上方图片
    };
  },
  methods: {
    toPage(name) {
      switch (name) {
        case "calculator":
          this.toUrl("https://independentpage.xchengtech.cn/calculator.html");
          break;
        case "none":
          Toast.success("功能暂未开放，敬请期待");
          break;
        default:
          this.$router.push({ path: "/" + name });
          break;
      }
    },
    toUrl(url) {
      console.log("utl", url);
      if (url) {
        window.location.href = url;
      }
    },
  },
};
</script>

<style scoped>
.page {
  padding: 4vw 4vw 0 4vw;
  display: grid;
  grid-template-columns: 50% 50%;
  /* gap: 4vw; */
}

.page .left {
  /* padding-right: 2vw; */
}
.page .left .img-box {
  padding: 0 2vw 0 0;
}
.page .left img {
  border-radius: 8px;

  display: block;
  width: 100%;
  height: 100%;
}
.left-swipe {
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}
.page .right {
  padding-left: 2vw;
  display: grid;
  gap: 4vw;
}

.page .right .item {
  height: 20vw;
  position: relative;
}

.page .right .item img {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 8px;
  overflow: hidden;
  display: block;
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/productList/module/poster.vue